namespace Matrix.Indexation {
    export interface IndexTypeRow {
        IndexTypeCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
    }

    export namespace IndexTypeRow {
        export const idProperty = 'IndexTypeCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Indexation.IndexType';
        export const lookupKey = 'Indexation.IndexType';

        export function getLookup(): Q.Lookup<IndexTypeRow> {
            return Q.getLookup<IndexTypeRow>('Indexation.IndexType');
        }
        export const deletePermission = 'DataAdmin:IndexType';
        export const insertPermission = 'DataAdmin:IndexType';
        export const readPermission = 'Read:IndexType';
        export const updatePermission = 'DataAdmin:IndexType';

        export declare const enum Fields {
            IndexTypeCode = "IndexTypeCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder"
        }
    }
}
